import { render, staticRenderFns } from "./dataCollection.vue?vue&type=template&id=014743f9&scoped=true"
import script from "./dataCollection.vue?vue&type=script&lang=js"
export * from "./dataCollection.vue?vue&type=script&lang=js"
import style0 from "./dataCollection.vue?vue&type=style&index=0&id=014743f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014743f9",
  null
  
)

export default component.exports